export enum ScheduleModeEnum {
    off = 0,
    repeat,
    dayOfMonth,
    oneShot
}
